export default function CommentsSection() {
  const comments = [
    {
      name: '光影追梦人',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-1&orientation=squarish',
      date: '2026-07-28',
      text: '找了很久的777影院终于找到正确的入口了！之前总是被各种山寨站绕来绕去，现在固定收藏了这个页面，非常方便。资源更新也很快，热门剧集基本上第二天就能看到，画质也很清晰，强烈推荐！',
      rating: 5,
    },
    {
      name: '周末电影控',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-2&orientation=squarish',
      date: '2026-07-25',
      text: '作为一个重度电影爱好者，777影院是我的日常必备。分类导航做得很好，想找什么类型一目了然。纪录片专区尤其赞，BBC和国家地理的高清资源都有，画质很棒。希望能一直稳定运营下去！',
      rating: 5,
    },
    {
      name: '追剧小达人',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20cheerful%20expression&width=80&height=80&seq=avatar-3&orientation=squarish',
      date: '2026-07-22',
      text: '日韩剧集的更新速度真的没话说！追的几部韩剧都是同步更新的，字幕翻译质量也很高。手机上看起来也很流畅，上下班通勤路上追剧太舒服了。最满意的是没有任何广告骚扰，观影体验非常纯净。',
      rating: 4,
    },
  ];

  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听影迷朋友们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <article
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i
                    key={j}
                    className={`text-sm ${
                      j < comment.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-5 line-clamp-4">
                "{comment.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}